var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "mt-4 v-application",
      class: { "d-block": !_vm.isRestricted },
    },
    [
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "520" },
          model: {
            value: _vm.isPricingDialogOpen,
            callback: function ($$v) {
              _vm.isPricingDialogOpen = $$v
            },
            expression: "isPricingDialogOpen",
          },
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", [_vm._v("Preise ändern")]),
              _vm._v(" "),
              _c(
                "v-card-text",
                [
                  _c(
                    "v-alert",
                    { attrs: { dense: "", text: "", type: "info" } },
                    [
                      _vm._v(
                        "\n                    Frühere Abrechnungszeiträume bleiben unverändert. Ab dem Startdatum gelten die neuen Konditionen.\n                "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("v-text-field", {
                    attrs: {
                      outlined: "",
                      dense: "",
                      type: "date",
                      min: _vm.todayInBerlin(),
                      label: "Startdatum",
                      "data-test": "steffi-pricing-effective-date",
                    },
                    model: {
                      value: _vm.pricingForm.effective_date,
                      callback: function ($$v) {
                        _vm.$set(_vm.pricingForm, "effective_date", $$v)
                      },
                      expression: "pricingForm.effective_date",
                    },
                  }),
                  _vm._v(" "),
                  _c("v-text-field", {
                    attrs: {
                      outlined: "",
                      dense: "",
                      inputmode: "decimal",
                      label: "Neuer Monatspreis",
                      suffix: "€ netto",
                      "data-test": "steffi-pricing-monthly",
                    },
                    model: {
                      value: _vm.pricingForm.monthly_net,
                      callback: function ($$v) {
                        _vm.$set(_vm.pricingForm, "monthly_net", $$v)
                      },
                      expression: "pricingForm.monthly_net",
                    },
                  }),
                  _vm._v(" "),
                  _c("v-text-field", {
                    attrs: {
                      outlined: "",
                      dense: "",
                      inputmode: "decimal",
                      label: "Neuer Minutenpreis",
                      suffix: "€ netto",
                      "data-test": "steffi-pricing-usage",
                    },
                    model: {
                      value: _vm.pricingForm.usage_minute_net,
                      callback: function ($$v) {
                        _vm.$set(_vm.pricingForm, "usage_minute_net", $$v)
                      },
                      expression: "pricingForm.usage_minute_net",
                    },
                  }),
                  _vm._v(" "),
                  _c("v-text-field", {
                    attrs: {
                      outlined: "",
                      dense: "",
                      type: "number",
                      min: "0",
                      label: "Freiminuten pro Monat",
                      suffix: "Minuten",
                      "data-test": "steffi-pricing-included-minutes",
                    },
                    model: {
                      value: _vm.pricingForm.included_monthly_minutes,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.pricingForm,
                          "included_monthly_minutes",
                          $$v
                        )
                      },
                      expression: "pricingForm.included_monthly_minutes",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { text: "" },
                      on: {
                        click: function ($event) {
                          _vm.isPricingDialogOpen = false
                        },
                      },
                    },
                    [_vm._v("Abbrechen")]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "primary",
                        loading: _vm.isSavingPricing,
                        "data-test": "steffi-pricing-save",
                      },
                      on: { click: _vm.savePricing },
                    },
                    [_vm._v("Änderung speichern")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.isRestricted
        ? _c(
            "v-card",
            {
              staticClass: "mr-3",
              attrs: {
                outlined: "",
                rounded: "lg",
                "data-test": "steffi-team-pharmacy-contact",
              },
            },
            [
              _c("v-card-title", [_vm._v(_vm._s(_vm.context.pharmacy.name))]),
              _vm._v(" "),
              _c("v-card-text", [
                _c("div", { staticClass: "mb-2" }, [
                  _c("span", [_vm._v("Kundennummer:")]),
                  _vm._v(" "),
                  _c("span", { staticClass: "font-weight-bold body-1" }, [
                    _vm._v(_vm._s(_vm.context.pharmacy.customer_id || "-")),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "d-flex align-center mb-2" },
                  [
                    _c("span", [_vm._v("E-Mail:")]),
                    _vm._v(" "),
                    _vm.isEditingSteffiEmail
                      ? [
                          _c("v-text-field", {
                            staticClass: "ml-2 mr-1",
                            attrs: {
                              label: "Steffi-E-Mail-Adresse",
                              type: "email",
                              dense: "",
                              outlined: "",
                              "hide-details": "",
                              rules: [_vm.optionalEmailRule],
                              disabled: _vm.steffiEmailSaving,
                              "data-test": "steffi-contact-email",
                            },
                            model: {
                              value: _vm.localSteffiEmailDraft,
                              callback: function ($$v) {
                                _vm.localSteffiEmailDraft = $$v
                              },
                              expression: "localSteffiEmailDraft",
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                icon: "",
                                small: "",
                                color: "primary",
                                loading: _vm.steffiEmailSaving,
                                "data-test": "steffi-contact-email-save",
                                "aria-label": "Steffi-E-Mail-Adresse speichern",
                              },
                              on: { click: _vm.saveSteffiEmail },
                            },
                            [
                              _c("v-icon", { attrs: { small: "" } }, [
                                _vm._v("mdi-check"),
                              ]),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                icon: "",
                                small: "",
                                disabled: _vm.steffiEmailSaving,
                                "data-test": "steffi-contact-email-cancel",
                                "aria-label": "Bearbeiten abbrechen",
                              },
                              on: { click: _vm.cancelSteffiEmailEdit },
                            },
                            [
                              _c("v-icon", { attrs: { small: "" } }, [
                                _vm._v("mdi-close"),
                              ]),
                            ],
                            1
                          ),
                        ]
                      : [
                          _c(
                            "span",
                            {
                              staticClass: "font-weight-bold body-1 ml-1",
                              attrs: {
                                "data-test": "steffi-contact-email-display",
                              },
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(
                                    _vm.context.pharmacy.steffi_email ||
                                      _vm.context.pharmacy.invitation_email ||
                                      "-"
                                  ) +
                                  "\n                    "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                icon: "",
                                small: "",
                                "data-test": "steffi-contact-email-edit",
                                "aria-label":
                                  "Steffi-E-Mail-Adresse bearbeiten",
                              },
                              on: { click: _vm.startSteffiEmailEdit },
                            },
                            [
                              _c("v-icon", { attrs: { small: "" } }, [
                                _vm._v("mdi-pencil"),
                              ]),
                            ],
                            1
                          ),
                        ],
                  ],
                  2
                ),
                _vm._v(" "),
                _c("div", { staticClass: "mb-2" }, [
                  _c("span", [_vm._v("Telefon:")]),
                  _vm._v(" "),
                  _c("span", { staticClass: "font-weight-bold body-1" }, [
                    _vm._v(
                      _vm._s(
                        _vm.context.pharmacy.phone ||
                          _vm.context.pharmacy.mobile ||
                          "-"
                      )
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "mb-2" }, [
                  _c("span", [_vm._v("Angefragt:")]),
                  _vm._v(" "),
                  _c("span", { staticClass: "font-weight-bold body-1" }, [
                    _vm._v(
                      _vm._s(_vm.formatDate(_vm.current.requested_at) || "-")
                    ),
                  ]),
                ]),
              ]),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-card",
        { staticClass: "d-flex mb-3", attrs: { rounded: "lg", outlined: "" } },
        [
          _c(
            "v-card-text",
            [
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { staticClass: "hero", attrs: { cols: "12", sm: "5" } },
                    [
                      _c("div", { staticClass: "overline" }, [_vm._v("Paket")]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "mb-1" },
                        [
                          _c(
                            "v-icon",
                            { staticClass: "mr-1", attrs: { small: "" } },
                            [_vm._v("mdi-package-variant-closed")]
                          ),
                          _vm._v(" "),
                          _c("span", [_vm._v("Paketname:")]),
                          _vm._v(" "),
                          _c(
                            "span",
                            { staticClass: "font-weight-bold body-1" },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.current.plan_name ||
                                    _vm.current.plan_code ||
                                    "-"
                                )
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      !_vm.isRestricted
                        ? _c(
                            "div",
                            [
                              _c(
                                "div",
                                { staticClass: "mb-1" },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      staticClass: "mr-1",
                                      attrs: { small: "" },
                                    },
                                    [_vm._v("mdi-calendar-text-outline")]
                                  ),
                                  _vm._v(" "),
                                  _c("span", [_vm._v("Start:")]),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticClass: "font-weight-bold body-1" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.formatDate(
                                            _vm.current.start_date
                                          ) || "-"
                                        )
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "mb-2" },
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      staticClass: "mr-1",
                                      attrs: { small: "" },
                                    },
                                    [_vm._v("mdi-calendar-text-outline")]
                                  ),
                                  _vm._v(" "),
                                  _c("span", [_vm._v("Nächste Abrechnung:")]),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticClass: "font-weight-bold body-1" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.formatDate(
                                            _vm.current.next_billing_date
                                          ) || "-"
                                        )
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.current.pricing
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "mb-2",
                                      attrs: {
                                        "data-test": "steffi-current-pricing",
                                      },
                                    },
                                    [
                                      _c("div", [
                                        _vm._v("Einrichtung: "),
                                        _c("b", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.formatMoney(
                                                _vm.current.pricing.setup_net
                                              )
                                            ) + " netto"
                                          ),
                                        ]),
                                      ]),
                                      _vm._v(" "),
                                      _c("div", [
                                        _vm._v("Monatlich: "),
                                        _c("b", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.formatMoney(
                                                _vm.current.pricing.monthly_net
                                              )
                                            ) + " netto"
                                          ),
                                        ]),
                                      ]),
                                      _vm._v(" "),
                                      _c("div", [
                                        _vm._v("Minute: "),
                                        _c("b", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.formatMoney(
                                                _vm.current.pricing
                                                  .usage_minute_net
                                              )
                                            ) + " netto"
                                          ),
                                        ]),
                                      ]),
                                      _vm._v(" "),
                                      _c("div", [
                                        _vm._v("Freiminuten: "),
                                        _c("b", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.current.pricing
                                                .included_monthly_minutes || 0
                                            ) + " pro Monat"
                                          ),
                                        ]),
                                      ]),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              !_vm.isRestricted &&
                              _vm.current.can_change_pricing
                                ? _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        small: "",
                                        outlined: "",
                                        color: "primary",
                                        "data-test": "steffi-open-pricing",
                                      },
                                      on: { click: _vm.openPricingDialog },
                                    },
                                    [_vm._v("Preise ändern")]
                                  )
                                : _vm._e(),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.current.trial_status
                        ? _c(
                            "v-alert",
                            {
                              staticClass: "mt-3 mb-0",
                              attrs: {
                                type: "info",
                                dense: "",
                                outlined: "",
                                "data-test": "steffi-admin-trial-status",
                              },
                            },
                            [
                              _c("div", [
                                _vm._v(
                                  _vm._s(
                                    _vm.current.trial_expired
                                      ? "Testphase automatisch beendet"
                                      : _vm.trialStatusLabel(
                                          _vm.current.trial_status
                                        )
                                  )
                                ),
                              ]),
                              _vm._v(" "),
                              _vm.current.trial_started_at
                                ? _c("div", [
                                    _vm._v(
                                      "Testbeginn: " +
                                        _vm._s(
                                          _vm.formatDate(
                                            _vm.current.trial_started_at
                                          )
                                        )
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.current.trial_ends_at
                                ? _c("div", [
                                    _vm._v(
                                      "Testende: " +
                                        _vm._s(
                                          _vm.formatDate(
                                            _vm.current.trial_ends_at
                                          )
                                        )
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.current.trial_cancelled_at
                                ? _c("div", [
                                    _vm._v(
                                      "Beendet: " +
                                        _vm._s(
                                          _vm.formatDate(
                                            _vm.current.trial_cancelled_at
                                          )
                                        )
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.current.trial_cancellation_pending_at
                                ? _c(
                                    "div",
                                    {
                                      attrs: {
                                        "data-test":
                                          "steffi-trial-cancellation-pending",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                            Beendigung angefordert – technische Deaktivierung bei Famulor ausstehend.\n                        "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              !_vm.current.trial_expired &&
                              (_vm.current.trial_status === "requested" ||
                                _vm.current.trial_status === "running")
                                ? _c("div", [
                                    _vm._v(
                                      "\n                            14 Tage kostenlos, danach automatische Beendigung ohne Kosten.\n                            Ein kostenpflichtiges Abonnement muss separat gebucht werden.\n                        "
                                    ),
                                  ])
                                : _vm._e(),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.isRestricted && _vm.current.pending_change
                        ? _c(
                            "v-alert",
                            {
                              staticClass: "mt-3 mb-0",
                              attrs: {
                                type: "info",
                                dense: "",
                                outlined: "",
                                "data-test": "steffi-pending-pricing",
                              },
                            },
                            [
                              _c("div", [
                                _vm._v(
                                  "Geplante Preisänderung ab " +
                                    _vm._s(
                                      _vm.formatDate(
                                        _vm.current.pending_change.effective_at
                                      )
                                    )
                                ),
                              ]),
                              _vm._v(" "),
                              _vm.current.pending_change.pricing
                                ? [
                                    _c("div", [
                                      _vm._v("Monatlich: "),
                                      _c("b", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.formatMoney(
                                              _vm.current.pending_change.pricing
                                                .monthly_net
                                            )
                                          ) + " netto"
                                        ),
                                      ]),
                                    ]),
                                    _vm._v(" "),
                                    _c("div", [
                                      _vm._v("Minute: "),
                                      _c("b", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.formatMoney(
                                              _vm.current.pending_change.pricing
                                                .usage_minute_net
                                            )
                                          ) + " netto"
                                        ),
                                      ]),
                                    ]),
                                    _vm._v(" "),
                                    _c("div", [
                                      _vm._v("Freiminuten: "),
                                      _c("b", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.current.pending_change.pricing
                                              .included_monthly_minutes || 0
                                          ) + " pro Monat"
                                        ),
                                      ]),
                                    ]),
                                  ]
                                : _vm._e(),
                            ],
                            2
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-col",
                    { staticClass: "hero", attrs: { cols: "12", sm: "7" } },
                    [
                      _c("div", { staticClass: "overline" }, [
                        _vm._v("Einrichtung"),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "mb-1" }, [
                        _c("span", { staticClass: "hero-label" }, [
                          _vm._v("Instanz:"),
                        ]),
                        _vm._v(" "),
                        _vm.current.famulor_assistant_name
                          ? _c(
                              "span",
                              { staticClass: "font-weight-bold body-1" },
                              [
                                _vm._v(
                                  _vm._s(_vm.current.famulor_assistant_name)
                                ),
                              ]
                            )
                          : _c("span", [_vm._v("-")]),
                      ]),
                      _vm._v(" "),
                      _vm.current.famulor_assistant_id
                        ? _c("div", { staticClass: "mb-1" }, [
                            _c("span", { staticClass: "hero-label" }, [
                              _vm._v("Instanz ID:"),
                            ]),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "font-weight-bold body-1" },
                              [_vm._v(_vm._s(_vm.current.famulor_assistant_id))]
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "d-flex mt-1 mb-2" }, [
                        _c("div", { staticClass: "v-application d-block" }, [
                          _c("span", { staticClass: "hero-label" }, [
                            _vm._v("Steffi Nummer:"),
                          ]),
                          _vm._v(" "),
                          _vm.current.famulor_phone_number
                            ? _c(
                                "a",
                                {
                                  staticClass: "font-weight-bold body-1",
                                  attrs: {
                                    href: `tel:${_vm.current.famulor_phone_number}`,
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(_vm.current.famulor_phone_number) +
                                      "\n                            "
                                  ),
                                ]
                              )
                            : _c("span", [_vm._v("-")]),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "section",
                        [
                          _c(
                            "v-chip",
                            {
                              staticClass:
                                "pl-0 mr-2 lighten-5 font-weight-medium",
                              class: _vm.localStatusColor(
                                _vm.current.local_subscription_status
                              ),
                              attrs: {
                                small: "",
                                label: "",
                                "text-color": _vm.localStatusColor(
                                  _vm.current.local_subscription_status
                                ),
                              },
                            },
                            [
                              _c(
                                "v-icon",
                                {
                                  attrs: {
                                    color: _vm.localStatusColor(
                                      _vm.current.local_subscription_status
                                    ),
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                                mdi-circle-small\n                            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("span", { staticClass: "mr-2" }, [
                                _vm._v("FPP Status:"),
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "font-weight-bold" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.localStatusLabel(
                                      _vm.current.local_subscription_status
                                    )
                                  )
                                ),
                              ]),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-chip",
                            {
                              staticClass: "pl-0 lighten-5 font-weight-medium",
                              class: _vm.famulorStatusColor(
                                _vm.current.famulor_operational_status
                              ),
                              attrs: {
                                small: "",
                                label: "",
                                "text-color": _vm.famulorStatusColor(
                                  _vm.current.famulor_operational_status
                                ),
                              },
                            },
                            [
                              _c(
                                "v-icon",
                                {
                                  attrs: {
                                    color: _vm.famulorStatusColor(
                                      _vm.current.famulor_operational_status
                                    ),
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                                mdi-circle-small\n                            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("span", { staticClass: "mr-2" }, [
                                _vm._v("Technischer Status:"),
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "font-weight-bold" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.famulorStatusLabel(
                                      _vm.current.famulor_operational_status
                                    )
                                  )
                                ),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.context.provisioning_diagnostics
                        ? _c("div", { staticClass: "mt-3" }, [
                            _c(
                              "div",
                              { staticClass: "text-caption text--secondary" },
                              [_vm._v("Provisionierung")]
                            ),
                            _vm._v(" "),
                            _c("code", [_vm._v(_vm._s(_vm.diagnosticText))]),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "v-tooltip",
                        {
                          attrs: { top: "" },
                          scopedSlots: _vm._u([
                            {
                              key: "activator",
                              fn: function ({ on, attrs }) {
                                return [
                                  _c(
                                    "v-btn",
                                    _vm._g(
                                      _vm._b(
                                        {
                                          staticClass: "manual-setup-btn",
                                          attrs: {
                                            small: "",
                                            text: "",
                                            fab: "",
                                            color: "blue-grey",
                                            "data-test":
                                              "steffi-open-manual-setup",
                                          },
                                          on: {
                                            click: function ($event) {
                                              _vm.isSteffiManualSetupDialogOpen = true
                                            },
                                          },
                                        },
                                        "v-btn",
                                        attrs,
                                        false
                                      ),
                                      on
                                    ),
                                    [_c("v-icon", [_vm._v("mdi-cog-outline")])],
                                    1
                                  ),
                                ]
                              },
                            },
                          ]),
                        },
                        [
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              "\n                            Manuelle Einrichtung\n                        "
                            ),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.isRestricted &&
                  (_vm.current.can_cancel || _vm.cancellationBlockers.length)
                    ? _c(
                        "v-col",
                        { staticClass: "blocker-alert", attrs: { cols: "12" } },
                        [
                          _c("v-divider"),
                          _vm._v(" "),
                          _vm.cancellationBlockers.length
                            ? _c(
                                "v-alert",
                                {
                                  staticClass: "mt-3 mb-0",
                                  attrs: {
                                    type: "warning",
                                    dense: "",
                                    outlined: "",
                                    "data-test": "steffi-cancellation-blockers",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                        Kündigung derzeit nicht möglich:\n                        "
                                  ),
                                  _vm._l(
                                    _vm.cancellationBlockers,
                                    function (blocker) {
                                      return _c(
                                        "div",
                                        {
                                          key: blocker,
                                          staticClass: "font-weight-bold",
                                        },
                                        [
                                          _vm._v(
                                            "\n                            " +
                                              _vm._s(
                                                _vm.cancellationBlockerLabel(
                                                  blocker
                                                )
                                              ) +
                                              "\n                        "
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                ],
                                2
                              )
                            : _vm.current.can_cancel
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "v-application mt-5 d-flex align-center justify-center",
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "mr-4 body-2 d-flex align-center",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          ["requested", "running"].includes(
                                            _vm.current.trial_status
                                          )
                                            ? "Testphase beenden?"
                                            : "Abonnement kündigen?"
                                        )
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        color: "red",
                                        dark: "",
                                        small: "",
                                        depressed: "",
                                        loading: _vm.isCancellingSteffi,
                                        "data-test": "steffi-admin-cancel",
                                      },
                                      on: {
                                        click: function ($event) {
                                          _vm.isCancelSteffiDialogOpen = true
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          staticClass: "mr-4",
                                          attrs: { small: "", dark: "" },
                                        },
                                        [_vm._v("mdi-cancel")]
                                      ),
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(
                                            ["requested", "running"].includes(
                                              _vm.current.trial_status
                                            )
                                              ? "Testphase beenden"
                                              : "stornieren"
                                          ) +
                                          "\n                        "
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("steffi-manual-setup-dialog", {
        attrs: {
          "pharmacy-id": _vm.pharmacyId,
          current: _vm.current,
          "is-restricted": _vm.isRestricted,
          "route-generation": _vm.routeGeneration,
        },
        on: { "context-updated": _vm.forwardContextUpdated },
        model: {
          value: _vm.isSteffiManualSetupDialogOpen,
          callback: function ($$v) {
            _vm.isSteffiManualSetupDialogOpen = $$v
          },
          expression: "isSteffiManualSetupDialogOpen",
        },
      }),
      _vm._v(" "),
      _c("confirmation-dialog", {
        attrs: {
          message: ["requested", "running"].includes(_vm.current.trial_status)
            ? "Testphase endgültig beenden? Es entstehen keine Kosten und kein kostenpflichtiges Abonnement. Thomas wird zur technischen Deaktivierung informiert."
            : "Soll das Steffi-Abonnement wirklich gekündigt werden? Diese Aktion kann nicht rückgängig gemacht werden.",
        },
        on: { save: _vm.cancelSteffi },
        model: {
          value: _vm.isCancelSteffiDialogOpen,
          callback: function ($$v) {
            _vm.isCancelSteffiDialogOpen = $$v
          },
          expression: "isCancelSteffiDialogOpen",
        },
      }),
      _vm._v(" "),
      _vm.canViewCommercialData
        ? _c(
            "v-row",
            {
              attrs: { dense: "", "data-test": "steffi-admin-commercial-data" },
            },
            [
              _c(
                "v-col",
                { attrs: { cols: "12", md: "4" } },
                [
                  _c(
                    "v-card",
                    {
                      staticClass: "mb-3",
                      attrs: { outlined: "", rounded: "lg" },
                    },
                    [
                      _c("v-card-title", { staticClass: "overline" }, [
                        _vm._v("Rechnungen"),
                      ]),
                      _vm._v(" "),
                      _c(
                        "v-card-text",
                        [
                          _c(
                            "v-row",
                            [
                              _c(
                                "v-col",
                                { attrs: { cols: "4" } },
                                [
                                  _c(
                                    "v-alert",
                                    {
                                      staticClass: "mb-0 text-center",
                                      attrs: {
                                        dense: "",
                                        text: "",
                                        color: "blue darken-2",
                                      },
                                    },
                                    [
                                      _c(
                                        "h5",
                                        {
                                          staticClass:
                                            "text-h4 font-weight-bold",
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.invoiceSummary.open_count
                                            )
                                          ),
                                        ]
                                      ),
                                      _vm._v(
                                        "\n                                offen\n                            "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-col",
                                { attrs: { cols: "4" } },
                                [
                                  _c(
                                    "v-alert",
                                    {
                                      staticClass: "mb-0 text-center",
                                      attrs: {
                                        dense: "",
                                        text: "",
                                        color: "green darken-2",
                                      },
                                    },
                                    [
                                      _c(
                                        "h5",
                                        {
                                          staticClass:
                                            "text-h4 font-weight-bold",
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.invoiceSummary.paid_count
                                            )
                                          ),
                                        ]
                                      ),
                                      _vm._v(
                                        "\n                                bezahlt\n                            "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-col",
                                { attrs: { cols: "4" } },
                                [
                                  _c(
                                    "v-alert",
                                    {
                                      staticClass: "mb-0 text-center",
                                      attrs: {
                                        dense: "",
                                        text: "",
                                        color: "blue-grey darken-2",
                                      },
                                    },
                                    [
                                      _c(
                                        "h5",
                                        {
                                          staticClass:
                                            "text-h4 font-weight-bold",
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.invoiceSummary.created_count
                                            )
                                          ),
                                        ]
                                      ),
                                      _vm._v(
                                        "\n                                vorbereitet\n                            "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.invoiceSummary.latest_paid_at
                            ? _c("v-divider", { staticClass: "my-4" })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.invoiceSummary.latest_paid_at
                            ? _c("div", [
                                _c("span", [_vm._v("Letzte Zahlung:")]),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { staticClass: "font-weight-bold body-1" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.formatDate(
                                          _vm.invoiceSummary.latest_paid_at
                                        )
                                      )
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-col",
                { attrs: { cols: "12", md: "4" } },
                [
                  _c(
                    "v-card",
                    {
                      staticClass: "mb-3",
                      attrs: {
                        outlined: "",
                        rounded: "lg",
                        "data-test": "steffi-usage",
                      },
                    },
                    [
                      _c("v-card-title", { staticClass: "overline" }, [
                        _vm._v("Nutzung"),
                      ]),
                      _vm._v(" "),
                      _c(
                        "v-card-text",
                        [
                          _vm.usageSync.state === "not_applicable"
                            ? _c(
                                "div",
                                {
                                  staticClass: "caption",
                                  attrs: {
                                    "data-test": "steffi-usage-sync",
                                    "data-state": _vm.usageSync.state,
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(
                                        _vm.usageSyncLabel(_vm.usageSync.state)
                                      ) +
                                      "\n                    "
                                  ),
                                ]
                              )
                            : _c(
                                "v-alert",
                                {
                                  attrs: {
                                    dense: "",
                                    outlined: "",
                                    type:
                                      _vm.usageSync.state === "fresh"
                                        ? "success"
                                        : "warning",
                                    "data-test": "steffi-usage-sync",
                                    "data-state": _vm.usageSync.state,
                                  },
                                },
                                [
                                  _c("div", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.usageSyncLabel(_vm.usageSync.state)
                                      )
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  !_vm.usageSync.last_success_at &&
                                  _vm.usageSync.state !== "never_synced"
                                    ? _c("div", [
                                        _vm._v(
                                          "\n                            Nutzungsdaten noch nicht synchronisiert\n                        "
                                        ),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.usageSync.last_success_at
                                    ? _c("div", { staticClass: "caption" }, [
                                        _vm._v(
                                          "\n                            Letzte erfolgreiche Synchronisierung: " +
                                            _vm._s(
                                              _vm.formatUsageSyncDate(
                                                _vm.usageSync.last_success_at
                                              )
                                            ) +
                                            "\n                        "
                                        ),
                                      ])
                                    : _vm._e(),
                                ]
                              ),
                          _vm._v(" "),
                          _vm.usageSync.last_success_at ||
                          _vm.usageSummary.total_call_count
                            ? _c(
                                "v-row",
                                {
                                  staticClass: "v-application",
                                  attrs: { "data-test": "steffi-usage-counts" },
                                },
                                [
                                  _vm.usageSync.state !== "fresh"
                                    ? _c(
                                        "v-col",
                                        {
                                          staticClass: "pb-0 caption",
                                          attrs: { cols: "12" },
                                        },
                                        [
                                          _vm._v(
                                            "\n                            Bekannte Nutzung (unvollständig)\n                        "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "d-flex pb-0",
                                      attrs: { cols: "12", sm: "6" },
                                    },
                                    [
                                      _c(
                                        "v-avatar",
                                        {
                                          staticClass: "px-5 py-5 mr-3",
                                          attrs: {
                                            size: "26",
                                            color: "teal lighten-5",
                                          },
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            { attrs: { color: "teal" } },
                                            [_vm._v("mdi-phone")]
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "section",
                                        {
                                          class: {
                                            "status-card-info":
                                              _vm.$vuetify.breakpoint.xsOnly,
                                          },
                                        },
                                        [
                                          _c("h3", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.usageSummary
                                                  .total_call_count
                                              )
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "p",
                                            {
                                              staticClass:
                                                "mb-0 caption grey--text text--darken-1",
                                            },
                                            [_vm._v("Calls")]
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "d-flex pb-0",
                                      attrs: { cols: "12", sm: "6" },
                                    },
                                    [
                                      _c(
                                        "v-avatar",
                                        {
                                          staticClass: "px-5 py-5 mr-3",
                                          attrs: {
                                            size: "26",
                                            color: "purple lighten-5",
                                          },
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            { attrs: { color: "purple" } },
                                            [_vm._v("mdi-clock-outline")]
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "section",
                                        {
                                          class: {
                                            "status-card-info":
                                              _vm.$vuetify.breakpoint.xsOnly,
                                          },
                                        },
                                        [
                                          _c("h3", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.usageSummary
                                                  .total_billable_minutes
                                              )
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "p",
                                            {
                                              staticClass:
                                                "mb-0 caption grey--text text--darken-1",
                                            },
                                            [_vm._v("Minuten")]
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "d-flex",
                                      attrs: { cols: "12", sm: "6" },
                                    },
                                    [
                                      _c(
                                        "v-avatar",
                                        {
                                          staticClass: "px-5 py-5 mr-3",
                                          attrs: {
                                            size: "26",
                                            color: "orange lighten-5",
                                          },
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            { attrs: { color: "orange" } },
                                            [_vm._v("mdi-phone-clock")]
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "section",
                                        {
                                          class: {
                                            "status-card-info":
                                              _vm.$vuetify.breakpoint.xsOnly,
                                          },
                                        },
                                        [
                                          _c("h3", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.usageSummary
                                                  .pending_policy_count
                                              )
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "p",
                                            {
                                              staticClass:
                                                "mb-0 caption grey--text text--darken-1",
                                            },
                                            [_vm._v("Pending")]
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "d-flex",
                                      attrs: { cols: "12", sm: "6" },
                                    },
                                    [
                                      _c(
                                        "v-avatar",
                                        {
                                          staticClass: "px-5 py-5 mr-3",
                                          attrs: {
                                            size: "26",
                                            color: "red lighten-5",
                                          },
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            { attrs: { color: "red" } },
                                            [_vm._v("mdi-phone-cancel-outline")]
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "section",
                                        {
                                          class: {
                                            "status-card-info":
                                              _vm.$vuetify.breakpoint.xsOnly,
                                          },
                                        },
                                        [
                                          _c("h3", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.usageSummary
                                                  .non_billable_count
                                              )
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "p",
                                            {
                                              staticClass:
                                                "mb-0 caption grey--text text--darken-1",
                                            },
                                            [_vm._v("nicht abrechenbar")]
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.usageSummary.latest_occurred_at
                            ? _c("v-divider", { staticClass: "my-4" })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.usageSummary.latest_occurred_at
                            ? _c("div", [
                                _c("span", [_vm._v("Letzte Nutzung:")]),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { staticClass: "font-weight-bold body-1" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.formatDate(
                                          _vm.usageSummary.latest_occurred_at
                                        )
                                      )
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-col",
                { attrs: { cols: "12", md: "4" } },
                [
                  _c(
                    "v-card",
                    {
                      staticClass: "mb-3",
                      attrs: { outlined: "", rounded: "lg" },
                    },
                    [
                      _c("v-card-title", { staticClass: "overline" }, [
                        _vm._v("Legal"),
                      ]),
                      _vm._v(" "),
                      _vm.legalAcceptance
                        ? _c(
                            "v-card-text",
                            [
                              _c(
                                "div",
                                { staticClass: "d-flex justify-space-between" },
                                [
                                  _c("span", [_vm._v("Akzeptiert:")]),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticClass: "font-weight-bold" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.formatDate(
                                            _vm.legalAcceptance.accepted_at
                                          ) || "-"
                                        )
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("v-divider", { staticClass: "my-2" }),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "d-flex justify-space-between" },
                                [
                                  _c("span", [_vm._v("User:")]),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticClass: "font-weight-bold" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.legalAcceptance
                                            .accepted_by_display ||
                                            _vm.legalAcceptance.accepted_by ||
                                            _vm.legalAcceptance.customer_user_id
                                        )
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("v-divider", { staticClass: "my-2" }),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "d-flex justify-space-between" },
                                [
                                  _c("span", [
                                    _vm._v("Vertragsset angenommen:"),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "v-chip",
                                    {
                                      staticClass: "lighten-5",
                                      attrs: {
                                        small: "",
                                        label: "",
                                        color: _vm.legalAcceptance
                                          .accepted_contract_terms
                                          ? "green"
                                          : "red",
                                        "text-color": _vm.legalAcceptance
                                          .accepted_contract_terms
                                          ? "green"
                                          : "red",
                                      },
                                    },
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          staticClass: "mr-1",
                                          attrs: { small: "" },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.legalAcceptance
                                                .accepted_contract_terms
                                                ? "mdi-check-circle-outline"
                                                : "mdi-close-circle-outline-red"
                                            )
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        { staticClass: "font-weight-bold" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.legalAcceptance
                                                .accepted_contract_terms
                                                ? "Ja"
                                                : "Nein"
                                            )
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.legalAcceptance.accepted_contract_terms
                                ? _c("v-divider", { staticClass: "my-2" })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.legalAcceptance.contract_version
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex justify-space-between",
                                    },
                                    [
                                      _c("span", [_vm._v("Version:")]),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        { staticClass: "font-weight-bold" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.legalAcceptance
                                                .contract_version
                                            )
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.legalAcceptance.accepted_contract_terms
                                ? _c("v-divider", { staticClass: "my-2" })
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "d-flex justify-space-between" },
                                [
                                  _vm.legalAcceptance.contract_url
                                    ? _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            href: _vm.legalAcceptance
                                              .contract_url,
                                            target: "_blank",
                                            link: "",
                                            outlined: "",
                                            rel: "noopener",
                                            "x-small": "",
                                            color: "primary",
                                          },
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            { attrs: { small: "" } },
                                            [_vm._v("mdi-arrow-down-bold")]
                                          ),
                                          _vm._v(
                                            "\n                            Vertragsset öffnen\n                        "
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.legalAcceptance.agb_url
                                    ? _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            href: _vm.legalAcceptance.agb_url,
                                            target: "_blank",
                                            link: "",
                                            outlined: "",
                                            rel: "noopener",
                                            "x-small": "",
                                            color: "primary",
                                          },
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            { attrs: { small: "" } },
                                            [_vm._v("mdi-arrow-down-bold")]
                                          ),
                                          _vm._v(
                                            "\n                            Nutzungsbedingungen öffnen\n                        "
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _c("v-card-text", [
                            _c("span", { staticClass: "text--secondary" }, [
                              _vm._v("Keine Legal-Akzeptanz gespeichert."),
                            ]),
                          ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-row",
        [
          _vm.canViewCommercialData
            ? _c(
                "v-col",
                {
                  attrs: {
                    dense: "",
                    "data-test": "steffi-admin-recent-data",
                    cols: "12",
                  },
                },
                [
                  _c(
                    "v-card",
                    { staticClass: "mb-3", attrs: { outlined: "" } },
                    [
                      _c("v-card-title", { staticClass: "overline" }, [
                        _vm._v("Letzte Rechnungen"),
                      ]),
                      _vm._v(" "),
                      _c("v-divider"),
                      _vm._v(" "),
                      _c("v-simple-table", [
                        _c("thead", [
                          _c("tr", [
                            _c("th", [_vm._v("Ref")]),
                            _vm._v(" "),
                            _c("th", [_vm._v("Typ")]),
                            _vm._v(" "),
                            _c("th", [_vm._v("Status")]),
                            _vm._v(" "),
                            _c("th", [_vm._v("Zeitraum")]),
                            _vm._v(" "),
                            _c("th", [_vm._v("Summe")]),
                            _vm._v(" "),
                            _c("th", [_vm._v("Erstellt")]),
                            _vm._v(" "),
                            _c("th", [_vm._v("Bezahlt am")]),
                            _vm._v(" "),
                            _c("th"),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c(
                          "tbody",
                          [
                            _vm._l(_vm.latestInvoices, function (invoice) {
                              return _c("tr", { key: invoice.id }, [
                                _c("td", [_vm._v(_vm._s(invoice.ref || "-"))]),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(
                                    _vm._s(
                                      invoice.invoice_kind_label ||
                                        invoice.invoice_kind ||
                                        "-"
                                    )
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(
                                    _vm._s(
                                      invoice.status_label ||
                                        invoice.status ||
                                        "-"
                                    )
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(
                                    _vm._s(invoice.billing_period_label || "-")
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(
                                    _vm._s(
                                      invoice.uploaded_legacy_invoice
                                        ? "-"
                                        : _vm.formatInvoiceTotal(invoice.total)
                                    )
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.formatDate(invoice.created_at) || "-"
                                    )
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.formatDate(invoice.date_paid) || "-"
                                    )
                                  ),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  [
                                    _c(
                                      "v-btn",
                                      {
                                        attrs: {
                                          link: "",
                                          text: "",
                                          fab: "",
                                          small: "",
                                          href:
                                            invoice.download_url ||
                                            `${_vm.apobilanzOriginUrl}/product-invoices/${invoice.id}`,
                                          target: "_blank",
                                          rel: "noopener",
                                          color: "primary",
                                        },
                                      },
                                      [
                                        _c("v-icon", { attrs: { small: "" } }, [
                                          _vm._v("mdi-file-link-outline"),
                                        ]),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ])
                            }),
                            _vm._v(" "),
                            !_vm.latestInvoices.length
                              ? _c("tr", [
                                  _c(
                                    "td",
                                    {
                                      staticClass: "text--secondary",
                                      attrs: { colspan: "7" },
                                    },
                                    [
                                      _vm._v(
                                        "Keine Produktrechnungen gespeichert."
                                      ),
                                    ]
                                  ),
                                ])
                              : _vm._e(),
                          ],
                          2
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-row",
        [
          _vm.canViewHistory
            ? _c(
                "v-col",
                {
                  attrs: {
                    "data-test": "steffi-admin-history",
                    cols: "12",
                    md: _vm.canViewRecentReports ? 6 : 12,
                  },
                },
                [
                  _c(
                    "v-card",
                    { staticClass: "mb-3", attrs: { outlined: "" } },
                    [
                      _c(
                        "v-tabs",
                        {
                          staticClass: "mb-1",
                          attrs: { dense: "" },
                          model: {
                            value: _vm.historyTab,
                            callback: function ($$v) {
                              _vm.historyTab = $$v
                            },
                            expression: "historyTab",
                          },
                        },
                        [
                          _c("v-tab", [_vm._v("Ereignisse")]),
                          _vm._v(" "),
                          _c("v-tab", [_vm._v("Abonnementverlauf")]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("v-divider"),
                      _vm._v(" "),
                      _c(
                        "v-tabs-items",
                        {
                          model: {
                            value: _vm.historyTab,
                            callback: function ($$v) {
                              _vm.historyTab = $$v
                            },
                            expression: "historyTab",
                          },
                        },
                        [
                          _c(
                            "v-tab-item",
                            [
                              _c(
                                "v-card-text",
                                { staticClass: "history-container" },
                                [
                                  _vm.context.events.length
                                    ? _c(
                                        "v-timeline",
                                        {
                                          attrs: {
                                            "align-top": "",
                                            dense: "",
                                            "data-test":
                                              "steffi-admin-events-timeline",
                                          },
                                        },
                                        _vm._l(
                                          _vm.context.events,
                                          function (event) {
                                            return _c(
                                              "v-timeline-item",
                                              {
                                                key:
                                                  event.id ||
                                                  `${event.event_type}-${event.effective_at}`,
                                                attrs: {
                                                  color: _vm.eventMeta(
                                                    event.event_type
                                                  )?.color,
                                                  small: "",
                                                },
                                              },
                                              [
                                                _c(
                                                  "v-row",
                                                  { staticClass: "pt-1" },
                                                  [
                                                    _c(
                                                      "v-col",
                                                      {
                                                        staticClass:
                                                          "pt-2 pb-1 pb-sm-3",
                                                        attrs: {
                                                          cols: "12",
                                                          sm: "9",
                                                        },
                                                      },
                                                      [
                                                        _c("strong", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.eventMeta(
                                                                event.event_type
                                                              )?.label
                                                            )
                                                          ),
                                                        ]),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "text-caption",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                                                " +
                                                                _vm._s(
                                                                  _vm.actorLabel(
                                                                    event.actor_type
                                                                  )
                                                                ) +
                                                                "\n                                            "
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "v-col",
                                                      {
                                                        staticClass:
                                                          "font-weight-medium pt-0 pt-sm-2",
                                                        attrs: {
                                                          cols: "12",
                                                          sm: "3",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                                            " +
                                                            _vm._s(
                                                              _vm.formatDate(
                                                                event.effective_at ||
                                                                  event.created_at
                                                              ) || "-"
                                                            ) +
                                                            "\n                                        "
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            )
                                          }
                                        ),
                                        1
                                      )
                                    : _c(
                                        "p",
                                        { staticClass: "text--secondary mb-0" },
                                        [_vm._v("Keine Events gespeichert.")]
                                      ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-tab-item",
                            [
                              _c("v-simple-table", [
                                _c("thead", [
                                  _c("tr", [
                                    _c("th", [_vm._v("Status")]),
                                    _vm._v(" "),
                                    _c("th", [_vm._v("Paket")]),
                                    _vm._v(" "),
                                    _c("th", [_vm._v("Start")]),
                                    _vm._v(" "),
                                    _c("th", [_vm._v("Ende")]),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "tbody",
                                  [
                                    _vm._l(
                                      _vm.context.subscription_history,
                                      function (item) {
                                        return _c(
                                          "tr",
                                          { key: item.subscription_id },
                                          [
                                            _c("td", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.localStatusLabel(
                                                    item.status
                                                  )
                                                )
                                              ),
                                            ]),
                                            _vm._v(" "),
                                            _c("td", [
                                              _vm._v(
                                                _vm._s(
                                                  item.plan_name ||
                                                    item.plan_code
                                                )
                                              ),
                                            ]),
                                            _vm._v(" "),
                                            _c("td", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.formatDate(
                                                    item.start_date
                                                  ) || "-"
                                                )
                                              ),
                                            ]),
                                            _vm._v(" "),
                                            _c("td", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.formatDate(
                                                    item.end_date ||
                                                      item.cancelled_at
                                                  ) || "-"
                                                )
                                              ),
                                            ]),
                                          ]
                                        )
                                      }
                                    ),
                                    _vm._v(" "),
                                    !_vm.context.subscription_history.length
                                      ? _c("tr", [
                                          _c(
                                            "td",
                                            {
                                              staticClass: "text--secondary",
                                              attrs: { colspan: "4" },
                                            },
                                            [
                                              _vm._v(
                                                "Keine Historie gespeichert."
                                              ),
                                            ]
                                          ),
                                        ])
                                      : _vm._e(),
                                  ],
                                  2
                                ),
                              ]),
                              _vm._v(" "),
                              _c("v-divider"),
                              _vm._v(" "),
                              _c(
                                "v-simple-table",
                                {
                                  attrs: {
                                    "data-test": "steffi-pricing-history",
                                  },
                                },
                                [
                                  _c("thead", [
                                    _c("tr", [
                                      _c("th", [_vm._v("Preis gültig ab")]),
                                      _vm._v(" "),
                                      _c("th", [_vm._v("Gültig bis")]),
                                      _vm._v(" "),
                                      _c("th", [_vm._v("Monat netto")]),
                                      _vm._v(" "),
                                      _c("th", [_vm._v("Minute netto")]),
                                      _vm._v(" "),
                                      _c("th", [_vm._v("Freiminuten/Monat")]),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "tbody",
                                    _vm._l(
                                      _vm.context.pricing_history,
                                      function (item, index) {
                                        return _c(
                                          "tr",
                                          { key: `${item.start_at}-${index}` },
                                          [
                                            _c("td", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.formatDate(
                                                    item.start_at
                                                  ) || "-"
                                                )
                                              ),
                                            ]),
                                            _vm._v(" "),
                                            _c("td", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.formatDate(item.end_at) ||
                                                    "aktuell"
                                                )
                                              ),
                                            ]),
                                            _vm._v(" "),
                                            _c("td", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.formatMoney(
                                                    item.pricing.monthly_net
                                                  )
                                                )
                                              ),
                                            ]),
                                            _vm._v(" "),
                                            _c("td", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.formatMoney(
                                                    item.pricing
                                                      .usage_minute_net
                                                  )
                                                )
                                              ),
                                            ]),
                                            _vm._v(" "),
                                            _c("td", [
                                              _vm._v(
                                                _vm._s(
                                                  item.pricing
                                                    .included_monthly_minutes ||
                                                    0
                                                )
                                              ),
                                            ]),
                                          ]
                                        )
                                      }
                                    ),
                                    0
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.canViewCommercialData && _vm.canViewRecentReports
            ? _c(
                "v-col",
                {
                  attrs: {
                    dense: "",
                    "data-test": "steffi-admin-recent-data",
                    cols: "12",
                    md: "6",
                  },
                },
                [
                  _c(
                    "v-card",
                    { staticClass: "mb-3", attrs: { outlined: "" } },
                    [
                      _c("v-card-title", { staticClass: "overline" }, [
                        _vm._v("Letzte Berichte"),
                      ]),
                      _vm._v(" "),
                      _c("v-divider"),
                      _vm._v(" "),
                      _c("v-simple-table", [
                        _c("thead", [
                          _c("tr", [
                            _c("th", [_vm._v("Ref")]),
                            _vm._v(" "),
                            _c("th", [_vm._v("Typ")]),
                            _vm._v(" "),
                            _c("th", [_vm._v("Status")]),
                            _vm._v(" "),
                            _c("th", [_vm._v("Dauer")]),
                            _vm._v(" "),
                            _c("th", [_vm._v("Start")]),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c(
                          "tbody",
                          [
                            _vm._l(_vm.recentReports, function (report) {
                              return _c(
                                "tr",
                                { key: report.id || report.usage_event_id },
                                [
                                  _c("td", [
                                    _vm._v(_vm._s(report.reference || "-")),
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(_vm._s(report.source_type || "-")),
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(_vm._s(report.status || "-")),
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(report.duration_seconds || 0) + "s"
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.formatDate(report.started_at) || "-"
                                      )
                                    ),
                                  ]),
                                ]
                              )
                            }),
                            _vm._v(" "),
                            !_vm.recentReports.length
                              ? _c("tr", [
                                  _c(
                                    "td",
                                    {
                                      staticClass: "text--secondary",
                                      attrs: { colspan: "5" },
                                    },
                                    [_vm._v("Keine Berichte gespeichert.")]
                                  ),
                                ])
                              : _vm._e(),
                          ],
                          2
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }